export default {
  title: "",
  subtitle: "Status for Pay-Out transactions",
  path: "transaction_status_pay_out",
  paragraphs: [
    "There are different statuses a transaction can have, and not all of them will apply to every transaction. In sandbox mode, all registered transactions will be automatically processed (status: 'wired'), if there is sufficient balance in the internal cash-out bank account.",
    "Important: If you register a payout without enough available balance in the internal cash-out account, that payout transaction will block any subsequent payouts using the same account. These other payouts will remain in a pending status, even if there’s enough balance for them, until sufficient funds are available to complete the first pending payout.",
    "Example: You create a payout of 10,000.00, but your internal cash-out account has only 5,000.00. This transaction will remain in a pending status. If you then create another payout of 2,000.00, even though you have enough balance for it, it will also remain pending, blocked by the first payout.",
    "To resolve this, you can either add more funds to the internal cash-out account or contact our production team to cancel the first payout transaction."
  ],
  request: {},
  domainsProperties: [
    {
      name: "pending",
      values: "This status will occur if you didn't not have enough balance in the cash-out bank account to cover the transaction."
    },
    {
      name: "identified",
      values: "This means there was sufficient balance to cover the transaction, and the funds have already been allocated to the payout, however the wire transfer has not been executed yet."
    },
    {
      name: "exchanged",
      values: "This is an intermediate status indicating that the funds have been converted, but the payment has not yet been completed. It only applies to payouts involving a conversion from foreign currency to local currency and occurs after the 'identified' status."
    },
    {
      name: "wired",
      values: "This is the final status for payouts. It means the payment was successfully completed, and the funds have already been sent to the destination bank account."
    },
    {
      name: "canceled",
      values: "When for any reason the transaction cannot be concluded or need to be reversed, it is canceled."
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionStatusPayOut.js